<template>
    <div>
        <div 
            class="d-flex height-498 bg-cover"
            :style="`background-image: url('/wp-content/themes/rhiza/dist/assets/overlay.jpg')`">
        </div>
        <div class="container" v-if="post">
            <div class="row">
                <div class="col-xl-7 bg-white header-materia mb-4 mb-xl-5">
                    <div class="row mt-xl-5 mt-4 ml-xl-3 ml-0">
                        <div class="font-glacial-bold mr-2">
                           <img src="/wp-content/themes/rhiza/src/assets/traco-preto.png" class="px-2">{{dateFormat()}} |
                        </div>
                        <div class="font-glacial-regular text-uppercase">
                            <b-link router-tag="a" :to="`/blog/autor/${removeAcento(post._embedded.author[0].name)}`" v-if="$route.name == 'post'" class="autor">
                                AUTOR: {{post._embedded.author[0].name}}
                            </b-link>
                            <span v-else>AUTOR: {{post._embedded.author[0].name}}</span>
                        </div>
                    </div>
                    <h1 class="font-glacial-bold font-36 ml-xl-3 mt-2" v-html="post.title.rendered">
                    </h1>
                    <div class="text-categories-red font-glacial-bold font-18 ml-xl-2 ml-0">
                        <img src="/wp-content/themes/rhiza/src/assets/traco-laranja.png" class="px-2">{{post.pure_taxonomies.categories[0].name}}
                    </div>
                </div>  
            </div>
            <div class="row">
                <div class="col-12 text-gray content-blog" v-html="post.content.rendered"></div>
            </div>

            <div class="row" v-if="imgBHS">
                <div class="col-12 col-sm-6 col-md-4 col-xl-3" v-for="(bImage, index) in imgBHS" :key="index">
                    <div v-b-modal.modal-post-thumb @click="imgKey = index" class="mb-4 d-flex align-items-end bg height-200 btn-pointer border-round height-mobile bg-center"
                    :style="`background-image: url(${bImage.medium_large}); background-repeat: no-repeat; background-size: cover;`">
                        <div class="filter-bg" :style="`width: 100%;`"></div>
                    </div>
                </div>
            </div>

        </div>

        <div v-if="posts">
            <div class="container">
                <div class="row mb-xl-5 mb-3">
                    <div class="ml-3">
                        <h2 class="font-glacial-bold font-70">
                            relacionados
                        </h2>
                    </div>
                </div>
            </div>
            <div class="container-fluid relacionados mb-5 pb-xl-5 pb-0">
                <div class="row justify-content-center"> 
                    <div class="col-xl-12 col-10">
                        <transition enter-active-class="animated fadeInUp">
                            <slick class="eventos" :options="slickOptions">
                                <blog-item :type="$route.name" class="text-white pr-xl-0 pr-md-3 ml-md-1" :item="d" v-for="(d, index) in posts" :key="index"/>
                            </slick>
                        </transition>
                    </div>
                </div>
            </div>
        </div>

        <b-modal id="modal-post-thumb" hide-header centered hide-footer @shown="reloadSlick">
            <transition enter-active-class="animated fadeInUp">
                <slick ref="slickgallery" class="slick-materia-fotos" :options="slickOptionsGallery">
                    <div v-for="(bImage, index) in imgBHS" :key="index">
                        <img :src="bImage.large" :alt="bImage.title" class="box-post-gallery-image" :style="`width: ${resize(bImage, 'width')}px; height: ${resize(bImage, 'height')}px;`" />
                    </div>
                </slick>
            </transition>
        </b-modal>
    </div>
</template>
<script>

    export default {
        props:{
            data: null
        },
        data(){
            return{
                imgKey: null,
                imgBHS: [],
                slickOptionsGallery:{
                    arrows: true,
                    slidesToShow: 1,
                },

                post: null,
                posts: null,

                slickOptions:{
                    arrows: true,
                    slidesToShow: 5,
                    variableWidth: true,
                    responsive: [
                        {
                            breakpoint: 800,
                            settings:{
                                slidesToShow: 1,
                            }
                        },
                        {
                            breakpoint: 1100,
                            settings:{
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 1441,
                            settings:{
                                slidesToShow: 3,
                            }
                        },
                    ]
                }
            }
        },
        watch: {
            '$route.params.slug'(){
                this.retrievePost()
                this.loadPosts()
            } 
        },

        async created(){
            
            await this.retrievePost()
            await this.loadPosts()

            if (this.post) {
                var arrTitle = document.title.split('|');
                var [baseTitle] = arrTitle.slice(-1);
                var d = document.createElement('div');
                d.innerHTML = `${this.post.title.rendered} | ${baseTitle}`
                document.title = d.innerText
            }
        },

        methods:{
            reloadSlick() {
                try {
                    this.$refs.slickgallery.destroy()
                } catch (e) {
                    console.log('slick not exist')
                }

                var width = this.resize(this.imgBHS[0], 'width') + 100
                $('#modal-post-thumb').find('.modal-dialog').css({
                    width: `${width}px`,
                    'max-width': `${width}px`,
                });

                this.$nextTick(() => {
                    this.$refs.slickgallery.create()
                    this.$refs.slickgallery.goTo(this.imgKey, false)
                })
            },

            async retrievePost(){
                var url = `${window.SETTINGS.API_BASE_PATH}posts?_embed&slug=${this.$route.params.slug}`

                var response = await axios.get(url)

                this.post = response.data[0]

                if (this.post.acf && this.post.acf.galeria_2) {
                    for (let index = 0; index < this.post.acf.galeria_2.length; index++) {
                        var sizes  = this.post.acf.galeria_2[index].sizes;
                        this.imgBHS.push(sizes);
                    }
                }
            },

            resize(sizes, type) {
                var height = (window.innerHeight - 100);
                if (height > sizes['large-height']) {
                    height = sizes['large-height'];
                }
                var width = sizes['large-width'] * height / sizes['large-height'];

                if (window.innerHeight > window.innerWidth) {
                    width  = window.innerWidth - 100;
                    height = sizes['large-height'] * width / sizes['large-width']
                }

                if (type == 'width') {
                    return width;
                }
                return height;
            },

            async loadPosts(){
                var url = `${window.SETTINGS.API_BASE_PATH}posts?_embed&per_page=10&categories=${this.post.categories.join(',')}`

                var response = await axios.get(url)
                    this.posts = response.data
            },

            dateFormat(){
                if (this.post && this.post.date) {
                    return moment(this.post.date).format('DD [de] MMMM [de] YYYY').toUpperCase()
                }
            },

            removeAcento(text){
                text = text.replace(new RegExp('[ÁÀÂÃ]','gi'), 'a');
                text = text.replace(new RegExp('[ÉÈÊ]','gi'), 'e');
                text = text.replace(new RegExp('[ÍÌÎ]','gi'), 'i');
                text = text.replace(new RegExp('[ÓÒÔÕ]','gi'), 'o');
                text = text.replace(new RegExp('[ÚÙÛ]','gi'), 'u');
                text = text.replace(new RegExp('[Ç]','gi'), 'c');
                text = text.replace(' ', '-');
                
                return text.toLowerCase();	
            },
        }
    }
</script>
<style>
* {
    min-height: 0;
    min-width: 0
}

.box-post-gallery-image .btn-prev,
.box-post-gallery-image .btn-next {
    position: absolute;
    bottom: -45px;
    left: 0;
    right: 0;
    margin: 0 auto;
    display: block;
}

.autor,
.autor:hover {
    color: #212529
}

</style>


// WEBPACK FOOTER //
// src/components/materia.vue